import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import './app/shared/leaflet-global'; // sets window.L before any lazy chunk that loads leaflet.markercluster

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

